import { ServiceFetch } from '../service-fetch'

export default class PurchaseRequestListModel extends ServiceFetch {
    getPurchaseRequestListBy = (data) => this.authFetch({
        url: 'purchase-request-list/getPurchaseRequestListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}